export function InsertDocument (pEditor, pDocument)
{
  let currentInsertDocumentParams,
      isDocumentDialogOpen = false,
      documentDialogEditLink = '';


  this.queryOpenInsertDocumentDialogEnabled = (pButton, command) =>
  {
    return pEditor.link.inserter.queryOpenInsertLinkDialogEnabled(pButton, command);
  };


  this.queryInsertDocumentState = (pButton, command) =>
  {
    const currentImage = pEditor.image.getCurrentImage();

    if (currentImage && pEditor.image.getThumbnailLink(currentImage))
    {
      return false;
    }
    else
    {
      return pEditor.link.remover.queryRemoveLinkEnabled(pButton, command);
    }
  };


  this.openInsertDocumentDialog = (pButton) =>
  {
    currentInsertDocumentParams = pEditor.link.inserter.prepareInsertLinkDialog(pButton);
    currentInsertDocumentParams.mode = 'InsertDocument';
    currentInsertDocumentParams.title = (currentInsertDocumentParams.title.replace(/[\n\r]+/g, '').replace(/(<[\/\!]?[A-Za-z0-9-]+.*?>|(&nbsp;|\s)+)/ig, '') === '') ? '' : currentInsertDocumentParams.title;

    if (WA.isCaaS)
    {
      pEditor.pDialog = (pButton && pButton.getDialog()) ? pButton.getDialog() : BEditor.Dialogs['Resource'].dialog;

      if (!pEditor.pDialog)
      {
        return false;
      }

      if (currentInsertDocumentParams.isCommandValid)
      {
        pEditor.range.save();

        pEditor.pDialog.ResourceInsert.addHandler(insertDocument);
        pEditor.pDialog.Hide.addHandler(insertDocumentDialogClosed);
        pEditor.pDialog.showInsertResourceDialog({ dialogMode: BEditor.UI.InsertResourceDialog.Modes.File });

        isDocumentDialogOpen = true;
      }
    }
    else
    {
      pEditor.range.save();

      var onSave = function (params)
      {
        // pEditor.pThis.execCommand(null, 'insertDocument', params);
        insertDocument(null, params);
      };

      var onCancel = function()
      {
        pEditor.afterCloseDialog();
      };

      window.BEditor.openDialog('openInsertDocumentDialog', onSave, onCancel, currentInsertDocumentParams);
    }

    documentDialogEditLink = currentInsertDocumentParams.link;
    pEditor.afterOpenDialog();
  };


  function insertDocument (sender, args)
  {
    if (WA.isCaaS)
    {
      if (pEditor.pDialog)
      {
        pEditor.pDialog.ResourceInsert.removeHandler(insertDocument);
        pEditor.pDialog.Hide.removeHandler(insertDocumentDialogClosed);

        pEditor.link.inserter.insertLink(sender,
        {
          link: args.selectedItem.src,
          title: ((currentInsertDocumentParams != null && currentInsertDocumentParams.title != null && currentInsertDocumentParams.title !== '') ? currentInsertDocumentParams.title : args.selectedItem.displayName),
          openInNewWindow: true,
          isAnyFileUploaded: args.isAnyFileUploaded
        });
      }
    }
    else
    {
      pEditor.link.inserter.insertLink(sender,
      {
        link: args.fullPath,
        title: ((currentInsertDocumentParams != null && currentInsertDocumentParams.title != null && currentInsertDocumentParams.title !== '') ? currentInsertDocumentParams.title : args.name),
        openInNewWindow: true,
        isAnyFileUploaded: true
      });
    }

    currentInsertDocumentParams = null;
  }


  function insertDocumentDialogClosed (sender, args)
  {
    pEditor.pDialog.ResourceInsert.removeHandler(insertDocument);
    pEditor.pDialog.Hide.removeHandler(insertDocumentDialogClosed);
    currentInsertDocumentParams = null;
    waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'DocumentDialog', operation: (args.isAnyFileUploaded ? 'UploadOnly' : 'Nothing')});
    pEditor.afterCloseDialog();
  }


  Object.defineProperty(this, 'isDocumentDialogOpen', { get: () => isDocumentDialogOpen, set: v => { isDocumentDialogOpen = v }});
  Object.defineProperty(this, 'documentDialogEditLink', { get: () => documentDialogEditLink });
}